module.exports = __webpack_public_path__ + "img/gdzifei.324e547f.jpg";